<template>
  <div
    id="popup-modal"
    class="popup"
    v-if="show">
    <!-- Popup Container -->
    <div class="popup__container">

      <!-- Popup Header -->
      <div class="popup__header">
        {{ title }}
        <div
          id="popup-close"
          @click="$emit('hide')"
          @keydown.enter="$emit('hide')"
          tabindex="0"
        >
          <FontAwesomeIcon
            class="popup__close"
            icon="times"
          />
        </div>
      </div>

      <!-- Popup iframe -->
      <div class="popup__iframe-wrapper">
        <iframe
          frameborder="0"
          class="popup__iframe"
          :style="{ height: iframeHeight }"
          :src="url"
        />
      </div>
      <!-- Popup Footer -->
      <div
        class="popup__footer"
        @click="$emit('hide')"
        @keydown.enter="$emit('hide')"
        tabindex="0"
      >
        CLOSE THIS WINDOW
      </div>

    </div>
  </div>
</template>

<script>
import trapFocus from '@/utils/TrapFocus'

/**
 * <iframe-popup></iframe-popup>
 * @desc popup component for footer legal page links
 */
export default {
  // Name
  name: 'iframe-popup',

  // Props
  props: {
    show: Boolean,
    url: String,
    title: String
  },

  // Data
  data () {
    return {
      iframeHeight: 700
    }
  },

  watch: {
    show (popupActive) {
      if (popupActive) {
        this.$nextTick(() => {
          trapFocus()
          document.getElementById('popup-close').focus()
        })
      }
    }
  },

  methods: {
    handleResize () {
      this.iframeHeight = `${window.outerHeight - 70}px`
    }
  }
}
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 200000;
  line-height: 1.6;

  &__container {
    position: relative;
    width: 80%;
    max-width: 970px;
    margin: auto;
    background-color: #fff;
    height: 100%;
    z-index: 200000;
  }

  &__header,
  &__footer {
    background-color: #cdcdcd;
    font-size: 16px;
    color: #000;
    padding: 5px 10px;
    text-align: center;
  }

  &__header {
    display: flex;
    justify-content: space-between;

  }

  &__close {
    cursor: pointer;
    position: relative;
    font-size: 24px;
  }

  &__footer {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    &:focus:not(.focus-visible) {
      outline: none;
    }
    &:focus-visible {
      border: 2px solid blue;
    }
  }

  &__iframe-wrapper {
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 70px);
    overflow-y: scroll;
    @include breakpoint('desktop-up') {
      overflow-y: auto;
    }
  }

  &__iframe {
    position: relative;
    height: 100%;
    display: block;
    border: none;
    width: 100%;
    max-width: 970px;
    padding: 0;
    margin: 0;
    backface-visibility: hidden
  }

  #popup-close {
    &:focus:not(.focus-visible) {
      outline: none;
    }
    &:focus-visible {
      border: 2px solid blue;
    }
  }
}
</style>
